import { render, staticRenderFns } from "./ResultsViewMain.vue?vue&type=template&id=0ec91ec4&"
import script from "./ResultsViewMain.vue?vue&type=script&lang=ts&"
export * from "./ResultsViewMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports